const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

class LyleImageColumns extends HTMLElement {
  #revealObserver = null;
  #videoObserver = null;
  #motionQuery = null;

  connectedCallback() {
    this.#motionQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    this.#motionQuery.addEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );

    this.#initAnimation();
    this.#initVideoPlayback();
  }

  disconnectedCallback() {
    this.#revealObserver?.disconnect();
    this.#revealObserver = null;

    this.#videoObserver?.disconnect();
    this.#videoObserver = null;

    this.#motionQuery?.removeEventListener(
      "change",
      this.#handleMotionPreferenceChange,
    );
    this.#motionQuery = null;
  }

  #handleMotionPreferenceChange = () => {
    if (this.#motionQuery?.matches) {
      this.classList.add("is-active");
      this.#revealObserver?.disconnect();
      this.#revealObserver = null;
    }
  };

  #initAnimation() {
    if (this.#motionQuery?.matches || !("IntersectionObserver" in window)) {
      this.classList.add("is-active");
      return;
    }

    this.classList.add("is-observed");

    this.#revealObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;

        this.classList.add("is-active");
        this.#revealObserver?.disconnect();
        this.#revealObserver = null;
      },
      { threshold: 0.2 },
    );

    this.#revealObserver.observe(this);
  }

  #initVideoPlayback() {
    const videos = [...this.querySelectorAll("[data-image-columns-video]")];

    if (videos.length === 0) return;

    if (this.#motionQuery?.matches || !("IntersectionObserver" in window)) {
      return;
    }

    this.#videoObserver = new IntersectionObserver(
      (entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          const video = entry.target;
          if (video.paused) {
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => {});
          }

          observer.unobserve(video);
        }
      },
      { threshold: 0.1 },
    );

    for (const video of videos) {
      this.#videoObserver.observe(video);
    }
  }
}

if (!customElements.get("lyle-image-columns")) {
  customElements.define("lyle-image-columns", LyleImageColumns);
}
